module.exports = __webpack_public_path__ + "img/42.77a66be4.jpg";